import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 21a1 1 0 0 1 0 -2h1v-2h-4a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-4v2h1a1 1 0 0 1 0 2zm7 -4h-4v2h4z","key":"svg-0"}]]

const IconDeviceDesktopFilled = createReactComponent('filled', 'device-desktop-filled', 'DeviceDesktopFilled', __iconNode);

export default IconDeviceDesktopFilled;